import { buildAnalyticsLogger } from '@ga/utils'

/** Возвращает конфигурацию GTM */
export const getGtmConfig = () => useRuntimeConfig().public.gtm || {}

/** Создает логгер для GTM */
export const buildGtmLogger = () => {
  const { debug } = getGtmConfig()

  return buildAnalyticsLogger({
    debug,
    styles: `
      background: #4285f4;
      border-radius: 0.5em;
      color: white;
      font-weight: bold;
      padding: 2px 0.5em;
    `,
    loggerPrependMessage: '%cGTM',
  })
}
